import React, { useEffect, useCallback } from 'react';
import './NotificationsMenuDrawer.css';

function NotificationsMenuDrawer({
  isOpen,
  onClose,
  onMarkAllAsRead,
  onDeleteAll,
}) {
  // ESC to close
  const handleKeyDown = useCallback(
    (e) => { if (e.key === 'Escape') onClose?.(); },
    [onClose]
  );

  useEffect(() => {
    if (!isOpen) return;
    document.addEventListener('keydown', handleKeyDown);
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = original;
    };
  }, [isOpen, handleKeyDown]);

  return (
    <>
      <div
        className={`nm-backdrop ${isOpen ? 'nm-backdrop--show' : ''}`}
        onClick={onClose}
        aria-hidden={!isOpen}
      />
      <aside
        className={`nm-sheet ${isOpen ? 'nm-sheet--open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Notifications menu"
      >
        <div className="nm-grabber" />
        <div className="nm-header">
          <h3 className="nm-title">Notifications</h3>
          <button className="nm-close" onClick={onClose} aria-label="Close menu">✕</button>
        </div>

        <div className="nm-list" role="menu">
          <button
            className="nm-item"
            role="menuitem"
            onClick={() => {
              onClose?.();
              setTimeout(() => onMarkAllAsRead?.(), 0);
            }}
          >
            <span className="nm-label">Mark All as Read</span>
          </button>

          <button
            className="nm-item nm-item--danger"
            role="menuitem"
            onClick={() => {
              onDeleteAll?.();
            }}
          >
            <span className="nm-label">Delete All</span>
          </button>
        </div>

        <div className="nm-safearea" />
      </aside>
    </>
  );
}

export default NotificationsMenuDrawer;
